<div class="phone-input-wrapper">
  <!-- Country picker trigger -->
  @if (hasMultipleCountries()) {
    <button
      type="button"
      class="country-trigger"
      [matMenuTriggerFor]="countryMenu"
      [disabled]="disabled"
      (menuOpened)="handleMenuOpened()"
      (menuClosed)="handleMenuClosed()"
    >
      <span
        class="fi flag-icon"
        [ngClass]="'fi-' + selectedCountryCode().toLowerCase()"
      ></span>
      <span class="dial-code">+{{ selectedCountry().dialCode }}</span>
      <span class="dropdown-arrow">
        <mat-icon>arrow_drop_down</mat-icon>
      </span>
    </button>
  } @else {
    <span class="country-trigger country-trigger--static">
      <span
        class="fi flag-icon"
        [ngClass]="'fi-' + selectedCountryCode().toLowerCase()"
      ></span>
      <span class="dial-code">+{{ selectedCountry().dialCode }}</span>
    </span>
  }

  <!-- Country menu panel -->
  <mat-menu #countryMenu="matMenu" class="country-menu-panel">
    @if (searchable()) {
      <div
        class="country-search-container flex items-center text-gray-700"
        (click)="$event.stopPropagation()"
        role="presentation"
      >
        <mat-icon class="absolute pointer-events-none">search</mat-icon>
        <input
          #searchInput
          class="country-search-input"
          type="text"
          placeholder="Zoeken..."
          autocomplete="off"
          [value]="searchQuery()"
          (input)="handleSearchInput($any($event.target).value)"
          (keydown)="$event.stopPropagation()"
        />
      </div>
    }

    @for (country of filteredPreferredList(); track country.code) {
      <button mat-menu-item (click)="handleCountryChange(country.code)">
        <span
          class="fi flag-icon"
          [ngClass]="'fi-' + country.code.toLowerCase()"
        ></span>
        <span class="menu-item-label">{{ formatOptionLabel(country) }}</span>
      </button>
    }

    @if (showFilteredDivider()) {
      <mat-divider></mat-divider>
    }

    @for (country of filteredOtherList(); track country.code) {
      <button mat-menu-item (click)="handleCountryChange(country.code)">
        <span
          class="fi flag-icon"
          [ngClass]="'fi-' + country.code.toLowerCase()"
        ></span>
        <span class="menu-item-label">{{ formatOptionLabel(country) }}</span>
      </button>
    }
  </mat-menu>

  <!-- Phone number input -->
  <input
    matInput
    #numberInput
    [id]="inputId()"
    class="number-input"
    type="tel"
    autocomplete="off"
    enterkeyhint="next"
    [placeholder]="selectedCountry().example"
    [disabled]="disabled"
    [value]="localNumber()"
    (input)="handleNumberInput($event)"
    (blur)="handleBlur()"
  />
</div>
